// extracted by mini-css-extract-plugin
export default {"inputWrapper":"IncrementInput_inputWrapper__iC7xR","arrowWrapper":"IncrementInput_arrowWrapper__yX6jz"};